import { useMemo, useState } from 'react';
import { createIndexedDBStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/indexed-db/index.tsx';
import type { BrowserStorageCleanup } from '../../common/types.tsx';
import { BROWSER_STORAGE_PREFIX } from '../constants.tsx';

export interface BrowserStorageCleanupService {
	getBrowserStorageCleanup: () => Promise<BrowserStorageCleanup | undefined>;
	createBrowserStorageCleanup: (data: BrowserStorageCleanup) => Promise<BrowserStorageCleanup>;
	updateBrowserStorageCleanup: (data: BrowserStorageCleanup) => Promise<BrowserStorageCleanup>;
	deleteBrowserStorageCleanup: () => Promise<void>;
}

const KEY = 'browser-storage-cleanup';

export const useBrowserStorageCleanupService = (): BrowserStorageCleanupService => {
	const [storage] = useState(
		createIndexedDBStorageProvider(`${BROWSER_STORAGE_PREFIX}${KEY}`, {
			shouldAutoReconnect: true,
		}),
	);

	return useMemo(
		() => ({
			getBrowserStorageCleanup: async () => storage.get(KEY),
			createBrowserStorageCleanup: async (data) => {
				await storage.set(KEY, data);
				return data;
			},
			updateBrowserStorageCleanup: async (data) => {
				await storage.set(KEY, data);
				return data;
			},
			deleteBrowserStorageCleanup: async () => {
				await storage.remove(KEY);
			},
		}),
		[storage],
	);
};
